import useHover from "@/hooks/useHover";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import React, { useEffect, useRef, useState } from "react";
import styles from "./checkbox-dropdown.module.scss";

export type CheckboxDropdownItem = {
  label: any;
  value: any;
};

export type CheckboxDropdownPropsType = {
  label: string;
  items: CheckboxDropdownItem[];
  onChange?: Function;
  selected?: any[];
};

const CheckboxDropdown = ({
  label,
  items,
  onChange,
  selected: prevSelected,
}: CheckboxDropdownPropsType) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<any[]>(prevSelected || []);

  useHover(
    ref,
    () => setOpen(true),
    () => setOpen(false)
  );
  useOnClickOutside(ref, () => setOpen(false));

  useEffect(() => {
    setSelected(prevSelected || []);
  }, [prevSelected]);

  const checkboxChange = (e: any) => {
    let newValues = [];
    if (e.target.checked) {
      newValues = [...selected, e.target.value];
    } else {
      newValues = selected.filter((v) => v != e.target.value);
    }
    setSelected(newValues);
    if (onChange) {
      onChange(newValues);
    }
  };

  return (
    <div className={styles.select} ref={ref}>
      <ul>
        <li onClick={() => setOpen(!open)}>
          {label}
          {open ? (
            <i className="bi bi-caret-up-fill"></i>
          ) : (
            <i className="bi bi-caret-down-fill"></i>
          )}
        </li>
        <ul className={`${styles.dropdown} ${!open ? "d-none" : ""}`}>
          {items.map((v, i) => (
            <li key={v.value}>
              <button aria-label="checkbox" role="button">
                <div className="form-check m-0 min-h">
                  <input
                    className="form-check-input input-filter-check"
                    type="checkbox"
                    id={v.value}
                    value={v.value}
                    onChange={checkboxChange}
                    checked={selected.includes(v.value)}
                  />
                  <label className="form-check-label" htmlFor={v.value}>
                    {v.label}
                  </label>
                </div>
              </button>
            </li>
          ))}
          {items.length == 0 && (
            <li onClick={() => setOpen(false)}>
              <button aria-label="No options" role="button">
                No options
              </button>
            </li>
          )}
        </ul>
      </ul>
    </div>
  );
};

export default CheckboxDropdown;
